import Vue from 'vue';
import axios from 'axios';
import Vuetable from 'vuetable-2';
import { sync } from 'vuex-router-sync';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';

// self-define components
import App from './App';
import router from './router';
import store from './vuex/store';

// font-awesome vue version
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

// settings of vue
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = true;
Vue.config.errorHandler = (err, vm, info) => {
  console.error(err, vm, info);
};

// Vuetable is used in Admin page.
Vue.use(Vuetable);

sync(store, router);

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});




// WEBPACK FOOTER //
// ./src/main.js